import {
  ButtonPayloadEnum,
  ButtonComponent as TButtonComponent,
} from "@aichat/types/socket/widget.types";
import ButtonComponent from "./button-component";
import { cn } from "@aichat/ui/lib/utils";
import { ArrowRight } from "lucide-react";
import { HandleSendComponentParams } from "@aichat/types/widget";
import { useWebWidgetConfig } from "../../../web-widget/use-web-widget-config";
import { getHSLAString } from "@aichat/aichat-lib";

type ButtonListProps = {
  type?: "portal-chat" | "widget-chat";
  isUser?: boolean;
  buttons: TButtonComponent[];
  // eslint-disable-next-line no-unused-vars
  handleSendComponent?: (params: HandleSendComponentParams) => void;
};
function ButtonList({
  buttons,
  type,
  isUser,
  handleSendComponent,
}: ButtonListProps) {
  const { brandColor } = useWebWidgetConfig();
  const brandColorHSLA = getHSLAString(brandColor);
  const isStarters = buttons.every(
    (btn) => btn.payload.type === ButtonPayloadEnum.STARTER,
  );

  return (
    <div
      className={cn("flex flex-wrap gap-2 mt-3 mb-3", {
        "flex-col mb-2 mt-3": isStarters,
        "justify-end": type === "portal-chat" && !isUser,
      })}
    >
      {buttons.map((button) => (
        <ButtonComponent
          key={button.label}
          payload={button.payload}
          variant="quickReply"
          style={{
            borderColor: brandColorHSLA,
          }}
          onClick={() => {
            if (!handleSendComponent) return;
            handleSendComponent({
              type: button.payload.type,
              value: button.payload.value,
            });
          }}
        >
          {button.label} {isStarters && <ArrowRight />}
        </ButtonComponent>
      ))}
    </div>
  );
}

export default ButtonList;
